module.exports = __webpack_public_path__ + "static/asset-delete-dc8b8c14fc715745a3387270c91f0180.png";